import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './styles';

const Separator = ({ classes }: any) => <div className={classes.root} />;

export default withStyles(styles)(Separator);
